const TOKEN_KEY = "token";

function normalizeStoredToken(raw) {
  if (!raw || raw === "null" || raw === "undefined") {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === "string" ? parsed : raw;
  } catch {
    return raw;
  }
}

export function readStoredAccessToken() {
  return normalizeStoredToken(localStorage.getItem(TOKEN_KEY));
}

export function writeStoredAccessToken(token) {
  if (!token) {
    localStorage.removeItem(TOKEN_KEY);
    return;
  }

  localStorage.setItem(TOKEN_KEY, token);
}

export function clearStoredAccessToken() {
  localStorage.removeItem(TOKEN_KEY);
}
